import { render, staticRenderFns } from "./AssetBuildingsView.vue?vue&type=template&id=39685d68&scoped=true"
import script from "./AssetBuildingsView.vue?vue&type=script&lang=js"
export * from "./AssetBuildingsView.vue?vue&type=script&lang=js"
import style0 from "./AssetBuildingsView.vue?vue&type=style&index=0&id=39685d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39685d68",
  null
  
)

export default component.exports